<template>
  <div v-if="airlines?.length" class="flex items-center gap-3 py-4">
    <h3
      v-if="isDirectFlights"
      class="text-text-neutral-primary whitespace-nowrap text-sm font-medium"
    >
      {{ t('main.searchFormCalendar.showDirectFlights') }}
    </h3>

    <div v-else-if="airlines.length > 0">
      <h3
        class="text-text-neutral-primary whitespace-nowrap text-sm font-medium"
      >
        {{ t('main.searchFormCalendar.upToOneTransfer') }}
      </h3>

      <div class="flex items-center gap-1">
        <img class="h-3 w-3" src="@/assets/images/note.svg" alt="" />
        <span class="text-text-neutral-quaternary text-xs text-gray-500">{{
          t('main.searchFormCalendar.noDirectFlights')
        }}</span>
      </div>
    </div>

    <div
      v-for="(airline, idx) in airlines"
      :key="idx"
      :class="idx >= 3 && 'hidden'"
    >
      <button
        type="button"
        class="bg-static-white flex h-10 w-10 items-center justify-center overflow-hidden rounded-2xl border"
        :class="
          selectedAirline?.iata === airline?.iata
            ? 'border-background-positive-primary w-16'
            : 'border-background-positive-secondary'
        "
        @click="onAirlineClick(airline)"
      >
        <img
          class="h-6 w-6"
          :src="`https://aviata.kz/static/airline-logos/80x80/${airline?.iata}.png`"
          alt=""
        />
        <img
          v-if="selectedAirline?.iata === airline?.iata"
          class="pl-1"
          src="@/assets/images/green-check.svg"
          alt=""
        />
      </button>
    </div>

    <div>
      <button
        v-if="airlines.length > 3"
        class="h-10 w-10 rounded-2xl bg-blue-100"
        @click="onBottomSheetClick"
      >
        <span v-if="airlines?.length" class="text-text-info-primary">
          +{{ airlines.length - 3 }}
        </span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import type { Dict } from '@aviata/platform-types';

  defineProps<{
    isDirectFlights: boolean;
    airlines: Dict.Airlines.Airline[] | null;
    selectedAirline: Dict.Airlines.Airline | null;
  }>();

  const emit = defineEmits<{
    onFilterByAirline: [airline: Dict.Airlines.Airline];
    onAirlinesListBottomSheet: [];
  }>();

  const { t } = useI18n();

  const onAirlineClick = (airline: Dict.Airlines.Airline) => {
    emit('onFilterByAirline', airline);
  };

  const onBottomSheetClick = () => {
    emit('onAirlinesListBottomSheet');
  };
</script>
